/* sts-small-size.js: v6.3 §3. Shoppers bought the travel size without
   noticing, then asked for a return. When the chosen size is the smaller
   one, every cart add asks first and adds NOTHING until OK: the PDP's Add
   to cart (only), Subscribe & save, Add to cart anyway and the sticky bar's
   buttons (assets/sts-product.js), the quick view's (sts-collection.js),
   and since v7.1 §2 the PDP's "+ Add to my routine" link
   (assets/sts-add-routine.js; travel titles also keep its own line).
   OK does the add that was pressed; Nevermind, x, Esc, a tap outside: none.
   Smaller = the variant metafield custom.is_travel_size when set, else the
   title, never the price. Title: sts-add-routine.js's NONRETAIL tokens that
   name a SMALLER size; pro size, back bar and kit are larger or not a size.
   A title whose size is not below the full size's never asks (same-size
   finishes). Full size = the largest (by ml/oz/g in the title) that is not
   smaller, retail before pro size, then the same finish. None: no ask.
   Data: snippets/sts-small-size.liquid. Pop-up: STS.popups.dialog.
   STS.smallSize.guard(root, variantId, go): go() now, after OK, or never.
   Simulator, unpublished theme: ?sts_travel=<id>,-<id> = metafield true/false. */
(function (w, d) {
  'use strict';
  var STS = (w.STS = w.STS || {});
  if (STS.smallSize) return;
  var SMALL = /sample|travel|tester|trial|mini/i, BIG = /pro[ _-]?size|back ?bar|kit/i;
  var UNIT = { oz: 29.57, ml: 1, l: 1000, g: 1, gm: 1, gr: 1, kg: 1000, lb: 453.6 };
  var SIM = {}, up = false, cssOn = false;

  try {
    var role = String((w.__STS_SERVER__ || {}).themeRole || ''), th = w.Shopify && w.Shopify.theme;
    if (role && role !== 'main' && !(th && th.role === 'main')) {
      String(new URLSearchParams(w.location.search).get('sts_travel') || '').split(',').forEach(function (s) {
        s = s.trim();
        if (s) SIM[s.replace(/^-/, '')] = s.charAt(0) !== '-';
      });
    }
  } catch (e) { /* no simulator */ }

  function mk(tag, cls, txt) {
    var n = d.createElement(tag);
    if (cls) n.className = cls;
    if (txt != null) n.textContent = txt;
    return n;
  }
  function flag(v) { var s = SIM[String(v.id)]; return s != null ? s : v.m; }
  function small(v) { var m = flag(v); return m != null ? !!m : SMALL.test(v.t); }
  /* ml, an ounce read as fluid; only compared within one product. 0 = none. */
  function size(t) {
    var m = /(\d+(?:\.\d+)?)\s*(fl\.?\s*oz|oz|ml|l|kg|gm?|gr|lb)\b/i.exec(t || '');
    return m ? m[1] * (UNIT[m[2].toLowerCase().replace(/^fl\.?\s*/, '')] || 1) : 0;
  }
  function words(t) { return String(t).toLowerCase().split(/[\s\/,()-]+/); }
  function shared(a, b) {
    var B = words(b);
    return words(a).filter(function (x) { return x && B.indexOf(x) > -1; }).length;
  }
  function full(vs, v) {
    var pool = vs.filter(function (x) { return !small(x); });
    var retail = pool.filter(function (x) { return !BIG.test(x.t); });
    var best = null;
    (retail.length ? retail : pool).forEach(function (x) {
      x.z = size(x.t);
      x.s = shared(x.t, v.t);
      if (!best || x.z > best.z || (x.z === best.z && x.s > best.s)) best = x;
    });
    return best;
  }
  function price(c) {
    var M = STS.money;
    return M ? M.cents(c, { trim: true }) : '$' + (c / 100).toFixed(2);
  }
  function css() {
    if (cssOn) return;
    cssOn = true;
    d.head.appendChild(mk('style', '', '.sts-small{display:flex;gap:14px;align-items:center;margin-bottom:14px}' +
      '.sts-small__img{flex:none;width:56px;height:56px;border-radius:12px;background:#F1F1F3;object-fit:contain}' +
      '.sts-small .sts-pop__eyebrow{margin:0}.sts-small__name{margin:0;font-size:13.5px;line-height:1.35;color:var(--sts-ink);text-wrap:pretty}' +
      '.sts-pop .sts-small__p{margin-bottom:18px}'));
  }

  function ask(D, v, f, go) {
    css();
    var row = mk('div', 'sts-small'), im = mk(D.img ? 'img' : 'span', 'sts-small__img'), tx = mk('div');
    if (D.img) { im.src = D.img; im.alt = ''; im.width = im.height = 56; }
    im.setAttribute('aria-hidden', 'true');
    tx.appendChild(mk('p', 'sts-pop__eyebrow', 'Smaller size'));
    tx.appendChild(mk('p', 'sts-small__name', D.name || ''));
    row.appendChild(im);
    row.appendChild(tx);
    var p = mk('p', 'sts-pop__body sts-small__p');
    p.appendChild(d.createTextNode('You picked '));
    p.appendChild(mk('b', '', v.t));
    p.appendChild(d.createTextNode(' for ' + price(v.p) + '. The full size is ' + f.t + ' for ' + price(f.p) + '.'));
    up = true;
    STS.popups.dialog({
      id: 'sts-small', width: 440, row: true,
      title: 'Please note, this is the smaller size of this product',
      content: p,
      buttons: [{ label: 'OK', value: 'ok' }, { label: 'Nevermind', value: 'no', outline: true }],
      onOpen: function (n) { var h = n.querySelector('.sts-pop__title'); h.parentNode.insertBefore(row, h); },
      onClose: function (val) { up = false; if (val === 'ok') go(); }
    });
  }

  function guard(root, id, go) {
    if (up) return;
    var j = root && root.querySelector('[data-sts-small]'), D = null, v = null;
    try { D = JSON.parse(j.textContent); } catch (e) { /* no data, no ask */ }
    var vs = (D && D.v) || [];
    vs.forEach(function (x) { if (String(x.id) === String(id)) v = x; });
    /* Never block a purchase: without the pop-up system it just adds. */
    if (!v || !small(v) || !STS.popups || !STS.popups.dialog || !STS.ui) return go();
    var f = full(vs, v), a = size(v.t);
    if (!f || (flag(v) == null && a && f.z && a >= f.z)) return go();
    ask(D, v, f, go);
  }

  STS.smallSize = { guard: guard };
}(window, document));
